import { ca } from '@cian/analytics';

export function trackClickMenu() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'top_menu',
    action: 'click',
    label: 'burger_menu',
  });
}
